/**
 * 这里记录了 IV 业务相关枚举，如 REWARD_MODE REWARD_PLAY_VALUE_MODE 等
 */

export const IV_REWARD_MODE = {
    CLOSE_MODE: 0,
    PLAY_MODE: 1,
}

export const IV_REWARD_PLAY_VALUE_MODE = {
    ALERT_RATE: 0, // 0 ~ 1
    ALERT_TIME: 1, // 0 ~ 100(s)
}

export const IV_REWARD_PLAY_VALUE = {
    ALERT_RATE_DEFAULT: .8,
    ALERT_TIME_DEFAULT: 5,
}